/*
 * Copyright (c) 2019
 *    Reliant Business Valuation, LLC - http://reliantvalue.com
 *    Author: Kirill Vizniuk - kirill@internalvaluation.com
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import { Component, ViewChild, ElementRef, Input, OnInit, Output, EventEmitter, HostListener } from '@angular/core';
import { SearchableProvider } from '../../../model/interface/searchable.provider';
import { Tag } from 'src/app/model/tag';

@Component({
  selector: 'tag-search',
  templateUrl: './tag-search.component.html',
  styleUrls: ['./tag-search.component.scss']
})

export class TagSearchComponent implements OnInit {

  @ViewChild('rootElement') rootElement: ElementRef;
  @ViewChild('container') container: ElementRef;
  @ViewChild('inputText') inputRef: ElementRef;
  @Input() provider: SearchableProvider = null;
  @Input() id: string;
  @Input() name: string;
  @Input() disabled = false;
  @Input() placeholder = '';
  @Input() required = false;
  @Input() selectedTags: Tag[] = [];
  @Output() tagRemoved: EventEmitter<boolean> = new EventEmitter();
  @Output() tagSelected: EventEmitter<void> = new EventEmitter<void>();

  inputValue = '';
  isLoading: boolean = false;
  totalItems: number = 0;
  tags: Tag[] = [];
  isOpen: boolean = false;

  constructor() {}

  ngOnInit(): void {
    if(!this.selectedTags)
      this.selectedTags = [];
  }

  @HostListener('document:click', ['$event.target'])
  clickedOutside(targetElement: any): void {
    let clickedInsideC = false;
    if(this.container)
      clickedInsideC = this.container.nativeElement.contains(targetElement);
    const clickedInside = this.rootElement.nativeElement.contains(targetElement);
    if (!clickedInside && !clickedInsideC)
      this.isOpen = false;
  }

  onKeydown(event: any): void {
    let keyCode = Number(event.which || event.charCode || event.keyCode);

    // Handle Backspace
    if(keyCode === 8 && this.inputValue === '' && this.selectedTags && this.selectedTags.length > 0){
      this.onRemove(this.selectedTags[this.selectedTags.length - 1]);
    }
  }

  onFocus(): void{
    this.isOpen = true;
    this.loadTags();
  }

  onBlur(): void{
    // this.isOpen = false;
    this.inputValue = '';
  }

  valueChanged(): void{
    if (this.provider){
      this.isOpen = true;
      this.loadTags();
    }
  }

  loadTags(): void{
    this.isLoading = true;

    let excluded = [];
    if(this.selectedTags)
      for(let t of this.selectedTags)
        excluded.push(t.ID);

    this.provider.search(this.inputValue, JSON.stringify(excluded))
      .subscribe(data => {
        if (data.success) {
          switch (this.provider.getSearchType()) {
          case 'TAG':
            this.tags = Tag.parseArray(data.result.items);
            break;
          default:
            break;
          }
          this.totalItems = data.result.totalItems;
          this.isLoading = false;
        }else{
          this.isLoading = false;
        }
      }, () => {
        this.isLoading = false;
      });
  }

  onTagSelected(tag: Tag): void{
    let tmpTag: any = tag;
    this.selectedTags.push(tag);
    this.tags = this.tags.filter((t) => {
      let matchFound = false;
      this.selectedTags.filter((s) => {
        if(t.ID === s.ID)
          matchFound = true;
      });

      if(!matchFound)
        return t;
    });
    this.tagSelected.emit(tmpTag);
  }

  onRemove(tag: Tag): void{
    let tmpTag: any = tag;
    this.selectedTags = this.selectedTags.filter((t) => {
      if(tag.ID != t.ID)
        return t;
    });
    this.tagRemoved.emit(tmpTag);
  }
}
